import { CheckboxSelector } from '@Knowledge-OTP/znk-ui-components'
import React, { useState } from 'react'
import useTranslation from '../../../i18n/useTranslation'
import isEqual from 'lodash/isEqual'
import FilterBadge from '../../../common/FilterBadge'

const TopicsFilter = (props) => {
  const { translate } = useTranslation()
  const { topics, setTopicFilters, topicFilters, serviceFilters } = props
  const [servicesCache, setServicesCache] = useState(null)
  if (!isEqual(servicesCache, serviceFilters)) {
    setServicesCache(serviceFilters)
    setTopicFilters([])
  }
  // Get Valid TopicIds Array based on selected services
  const validTopicIds = serviceFilters.reduce((arr, service) => arr.concat(service.topics.map(topic => topic.id)), [])
  const selectorData = topics.docs
    .filter(topic => validTopicIds.includes(topic.id))
    .map(item => ({ name: item.name, id: item.id }))
    .sort((a, b) => a.name.localeCompare(b.name))
  return (
    <CheckboxSelector
      setDataFilters={setTopicFilters}
      direction='bottom'
      dataFilters={topicFilters}
      data={selectorData}
      typeFilter='topics'
      strings={{
        viewAll: translate('filters.plans.viewAll'),
        buttonCancel: translate('filters.plans.buttonCancel'),
        buttonApply: translate('filters.plans.buttonApply'),
        search: translate('filters.plans.search')
      }}
    >
      <FilterBadge
        title={translate('filters.plans.topics.title')}
        options={selectorData}
        selectedIds={topicFilters}
        onClearFilters={() => setTopicFilters([])}
      />
    </CheckboxSelector>
  )
}
export default TopicsFilter
